import * as React from 'react';

import { CopilotKit } from '@copilotkit/react-core';

import { getToken } from '@api/client';

import { useCopilotUiApiKey } from './hooks/useCopilotUiApiKey';
import { StudioPage } from './StudioPage';

const AGENT_NAME = 'main';

export const StudioApp = () => {
  const token = getToken();
  const copilotKey = useCopilotUiApiKey();

  if (!copilotKey || !token) {
    return <div className='flex h-full' />;
  }

  return (
    <CopilotKit publicApiKey={copilotKey} agent={AGENT_NAME}>
      <StudioPage agentName={AGENT_NAME} token={token} />
    </CopilotKit>
  );
};
